/**
 * A calendar event's time as an instant (slice 3 §6.1's event card).
 * Calendar takes `start_datetime` with no offset and reads it in the call's
 * `timezone` (else the calendar's): so a wall time is read there, and one
 * with `Z` or an offset is the instant it says.
 */
import { zonedTime } from "./routine";

/** `2026-10-27`, `2026-10-27T14:00`, `2026-10-27 14:00:00.000`: no offset. */
const WALL = /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2})(?::\d{2}(?:\.\d+)?)?)?$/;

export function eventInstant(value: string | null, timeZone: string): Date | null {
  if (!value) return null;
  const wall = WALL.exec(value.trim());
  const at = wall ? zonedTime(wall[1]!, wall[2] ?? "00:00", timeZone) : new Date(value);
  return Number.isNaN(at.getTime()) ? null : at;
}
